import { sortBy } from 'es-toolkit';

/** Returns the given object with the keys in alphabetical order */
export function orderObjectKeys<T extends Record<string, unknown>>(obj: T): T {
  const entries = Object.entries(obj) as Array<[string, unknown]>;

  // sortBy expects an array of iteratees; '0' = first tuple item (the key)
  const ordered = sortBy(entries, ['0']);

  return Object.fromEntries(ordered) as T;
}
